// Automatically add noindex meta tags to utility pages
(function() {
  'use strict';

  // Check if this is a utility page that should not be indexed
  function isUtilityPage() {
    const pathname = window.location.pathname;
    
    // Check for tag header/footer pages
    if (pathname.match(/^\/tag-(header|footer)-/)) {
      return true;
    }
    
    // Check for other utility patterns
    if (pathname.match(/^\/(internal|private|utility|system)-/)) {
      return true;
    }
    
    return false;
  }

  // Add noindex meta tags
  function addNoIndexMeta() {
    console.log('🚫 Adding noindex meta tags to utility page');
    
    // Create and add robots meta tag
    const robotsMeta = document.createElement('meta');
    robotsMeta.name = 'robots';
    robotsMeta.content = 'noindex, nofollow';
    document.head.appendChild(robotsMeta);
    
    // Create and add googlebot meta tag
    const googlebotMeta = document.createElement('meta');
    googlebotMeta.name = 'googlebot';
    googlebotMeta.content = 'noindex, nofollow';
    document.head.appendChild(googlebotMeta);
    
    // Create and add bingbot meta tag
    const bingbotMeta = document.createElement('meta');
    bingbotMeta.name = 'bingbot';
    bingbotMeta.content = 'noindex, nofollow';
    document.head.appendChild(bingbotMeta);
    
    console.log('✅ Noindex meta tags added successfully');
  }

  // Run the check
  if (isUtilityPage()) {
    addNoIndexMeta();
  }
})();
